module.exports = __webpack_public_path__ + "static/media/deity-crate.55816384.jpg";